export default "__VITE_ASSET__DheqCOI9__"